export default "__VITE_ASSET__BW0Gkc8T__"